module.exports = __webpack_public_path__ + "static/media/CoopDashboard.a5c052b0.png";